export enum GeolocationPermissionsStatus {
  ACCEPTED,
  DENIED,
  UNKNOWN
}

export const GeolocationBrowserSettingsMessages: Record<string, string> = {
  edge: ` In your browser, go to: Settings -> View Advanced Settings -> Website permissions -> Manage -> Location and remove this site from your Block list.`,
  chrome: ` In your browser, go to: Preferences -> Advanced -> Privacy and security -> Site Settings -> Location and remove this site from your Block list.`,
  firefox: ` In your browser, go to: Preferences -> Privacy and security -> Location -> Settings and change this sites status to "Allow".`,
  safari: ` In your browser, go to: Preferences -> Websites -> Location and select "ask" or "allow" for this site.`,
  default: `You have previously denied geolocation to this page. Update your browser settings to share your location.`
};
